import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import LoginForm from "@/views/auth/LoginForm.vue";
import OTPForm from "@/views/auth/OTPForm.vue";
import PaymentSuccess from "@/views/payments/PaymentSuccess.vue";
import DynamicPaymentPage from "@/views/payments/DynamicPaymentPage.vue";
import SetUp from "@/views/auth/SetUp.vue";
import MultiForm from "@/views/kazang/MultiForm.vue";
import Layout from '@/components/utils/Layout.vue';
import ForgotPasswordForm from "@/views/auth/ForgotPasswordForm.vue";
import NotFound from "@/views/NotFound.vue";
import NotificationsPage from "@/views/NotificationsPage.vue";
import PaymentProofPage from "@/views/PaymentProofPage.vue";
import store from '@/store';

const isElectron = !!(typeof window !== 'undefined' && (window.process?.versions?.electron || window.electron));

// Module-level publicRoutes Set (shared by beforeEach and afterEach)
const publicRoutes = new Set(['LoginForm', 'ForgotPassword', 'OTPForm', 'SetUp', 'KazangRegistration', 'PaymentSuccess', 'DynamicPayment', 'NotFound', 'payment-proof', 'request-action']);

const routes = [
  {
    path: '/',
    name: 'LoginForm',
    component: LoginForm
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordForm
  },
  {
    path: '/OTP',
    name: 'OTPForm',
    component: OTPForm
  },
  {
    path: '/payments/success',
    name: 'PaymentSuccess',
    component: PaymentSuccess,
  },
  {
    path: '/payments/dynamic',
    name: 'DynamicPayment',
    component: DynamicPaymentPage,
  },
  {
    path: '/SetUp',
    name: 'SetUp',
    component: SetUp,
  },
  {
    path: '/register',
    name: 'KazangRegistration',
    component: MultiForm,
  },
  {
    path: '/payment-proof/:id',
    name: 'payment-proof',
    component: () => import(/* webpackChunkName: "PaymentProof" */ '../views/PaymentProofPage.vue'),
    props: true
  },
  {
    path: '/request-action',
    name: 'request-action',
    component: () => import(/* webpackChunkName: "PublicRequestAction" */ '../views/PublicRequestActionPage.vue')
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: 'incomingrequests',
        name: 'IncomingRequests',
        component: () => import(/* webpackChunkName: "IncomingRequests" */ '../views/requests/IncomingRequests.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'expense-requests/pending',
        name: 'IncomingExpenseRequests',
        component: () => import(/* webpackChunkName: "IncomingExpenseRequests" */ '../views/expenses/IncomingExpenseRequests.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'expenses/new',
        name: 'new-expense-request',
        component: () => import(/* webpackChunkName: "NewExpenseRequest" */ '../views/requests/NewRequest.vue'),
        props: { requestType: 'expense' },
        meta: { requiresAuth: true }
      },
      {
        path: 'expenses/supplier-payment',
        name: 'supplier-payment',
        component: () => import(/* webpackChunkName: "SupplierPayment" */ '../views/requests/SupplierPayment.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'expenses/grv-payments',
        name: 'grv-payments',
        component: () => import(/* webpackChunkName: "GRVPayments" */ '../views/expenses/GRVPayments.vue'),
        props: { requestType: 'expense' },
        meta: { requiresAuth: true }
      },
      {
        path: 'requests',
        name: 'my-requests',
        component: () => import(/* webpackChunkName: "MyRequests" */ '../views/requests/MyRequests.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'requests/new',
        name: 'requests-new',
        component: () => import(/* webpackChunkName: "NewExpenseRequest" */ '../views/requests/NewRequest.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'requests/:id',
        name: 'request-details',
        component: () => import(/* webpackChunkName: "RequestDetails" */ '../views/requests/RequestDetails.vue'),
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'notifications',
        name: 'notifications',
        component: () => import(/* webpackChunkName: "Notifications" */ '../views/NotificationsPage.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'approvals',
        name: 'approvals',
        component: () => import(/* webpackChunkName: "Approvals" */ '../views/expenses/IncomingExpenseRequests.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'admin',
        name: 'admin-panel',
        component: () => import(/* webpackChunkName: "AdminPanel" */ '../views/AdminPanel.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'reports',
        name: 'reports',
        component: () => import(/* webpackChunkName: "ReportsDashboard" */ '../views/reports/ReportsDashboard.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'reports/dashboard',
        name: 'ReportsDashboard',
        component: () => import(/* webpackChunkName: "ReportsDashboard" */ '../views/reports/ReportsDashboard.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'reports/expenses/:id',
        name: 'ExpenseBreakdown',
        component: () => import(/* webpackChunkName: "ExpenseBreakdown" */ '../views/reports/ExpenseBreakdown.vue'),
        props: true,
        meta: { requiresAuth: true }
      },
      {
        path: 'payments/create-link',
        name: 'KazangWithdrawal',
        component: () => import(/* webpackChunkName: "KazangWithdrawal" */ '../views/payments/KanzangWithdraw.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'payments/payment-link',
        name: 'PaymentLinkCreator',
        component: () => import(/* webpackChunkName: "PaymentLinkCreator" */ '../views/payments/PaymentLinkCreator.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'payments/deposit',
        name: 'KazangDeposit',
        component: () => import(/* webpackChunkName: "KazangDeposit" */ '../views/payments/DepositForm.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'expense-requests/pending-otp',
        name: 'PendingDeposits',
        component: () => import(/* webpackChunkName: "PendingDeposits" */ '../views/expenses/PendingDeposits.vue'),
        meta: { requiresAuth: true }
      },
    ]
  },
  // Catch-all route for 404 Not Found
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFound
  }
]

const router = createRouter({
  // Use HTML5 history mode for web; hash mode only for Electron/file:// builds
  history: isElectron ? createWebHashHistory() : createWebHistory(import.meta.env.BASE_URL || '/'),
  routes
})

// Track page views for authenticated routes (per D-13)
router.afterEach((to) => {
  const requiresAuth = to.matched.some(record => record.meta?.requiresAuth)
  if (!requiresAuth || publicRoutes.has(to.name)) return
  window.$analytics?.trackPage(to.name)
})

// Navigation guard to check for session_id and handle public routes + hydration
router.beforeEach((to, from, next) => {
  // publicRoutes is now at module level (shared with afterEach)       
  // Auth entry pages (redirect away if already authenticated)
  const authEntryRoutes = new Set(['LoginForm', 'ForgotPassword', 'OTPForm', 'SetUp']);

  const proceed = () => {
    const hasSessionId = !!store.state.LoginModule.session_id;
    const hasBranch = !!store.state.LoginModule.branch;
    const isPublic = publicRoutes.has(to.name);
    const requiresAuth = to.matched.some(record => record.meta?.requiresAuth);
    const goingToAuthEntry = authEntryRoutes.has(to.name);

    // Handle WhatsApp shortcut actions (approve/decline)
    if (to.name === 'approvals' && to.query.action && to.query.id) {
      console.log('[Router] Handling WhatsApp shortcut action:', to.query.action, 'for request:', to.query.id);
      // Store the action to be handled by the component after navigation
      to.query._isFromWhatsApp = true;
    }

    // Prevent unauthenticated access to SetUp page (it needs a logged-in user)
    if (to.name === 'SetUp' && !hasSessionId) {
      console.log('[Router] SetUp page requires authentication, redirecting to login');
      next({ name: 'LoginForm' });
      return;
    }

    // Check if route requires authentication but user is not logged in
    if (requiresAuth && !hasSessionId) {
      console.log('[Router] Route requires authentication but user is not logged in, redirecting to login');
      next({ name: 'LoginForm' });
      return;
    }

    if (!isPublic && !hasSessionId) {
      // Redirect to login page if session_id doesn't exist
      console.log('[Router] Non-public route accessed without authentication, redirecting to login');
      next({ name: 'LoginForm' });
    } else if (hasSessionId && !hasBranch && to.name !== 'SetUp') {
      // Authenticated but no branch selected; force branch selection
      console.log('[Router] User authenticated but no branch selected, forcing branch selection');
      next({ name: 'SetUp' });
    } else if (isPublic && hasSessionId && goingToAuthEntry) {
      // Already authenticated: avoid auth entry pages
      if (!hasBranch) {
        // Stay on SetUp until branch is selected
        if (to.name === 'SetUp') {
          next();
        } else {
          next({ name: 'SetUp' });
        }
      } else {
        next({ name: 'my-requests' });
      }
    } else {
      // All checks passed, proceed to route
      console.log('[Router] Navigation allowed to:', to.name);
      next();
    }
  };

  // Wait for persisted store hydration before deciding
  if (!store.getters.isHydrated) {
    const unwatch = store.watch(
      (state) => state.isHydrated,
      (hydrated) => {
        if (hydrated) {
          unwatch();
          proceed();
        }
      }
    );
  } else {
    proceed();
  }
});

export default router
